import useEventListener from './useEventListener';

function usePreventLeaving({ skip }: { skip?: boolean }) {
  useEventListener(
    window,
    'beforeunload',
    (event) => {
      event.preventDefault();
      // Chrome requires returnValue to be set
      // eslint-disable-next-line no-param-reassign
      event.returnValue = '';
      // Safari requires a string to be returned
      return '';
    },
    { skip },
  );
}

export default usePreventLeaving;
